// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"1d0fe24f","140":"3456456e","292":"61965dff","560":"9677086f","680":"32402c87","721":"4e76ad6c"}[chunkId] + ".chunk.css";
};